enum Phase {
  Placement = 1,
  Resolution = 2,
}

export default Phase
